import React from 'react'
import tw from 'tailwind-styled-components'
import {Icon} from '@components/common/base/icon'
import {ValidType} from './emails-input'

const TwContainer = tw.div<{$valid?: ValidType}>`
  rounded-6
  border-1
  border-solid
  px-8
  py-4

  flex
  gap-8
  items-center

  ${p => {
    if (p.$valid === 'error') {
      return 'border-status-error bg-sticker-red'
    }

    if (p.$valid === 'warning') {
      return 'border-status-error bg-sticker-orange'
    }

    return 'border-line-base bg-sticker-blue'
  }}
`

const TwTitle = tw.div<{$valid?: ValidType}>`
  text-xs-regular
  cursor-default

  ${p => {
    if (p.$valid === 'error') {
      return 'text-status-error'
    }

    if (p.$valid === 'warning') {
      return 'text-status-warning'
    }

    return 'text-primary'
  }}
`

const TwClose = tw.div`
  w-8
  h-8
  flex
  items-center
  justify-center
  cursor-pointer
`

interface Props {
  close?: () => void
  text: string
  valid?: ValidType
}

export const EmailItem = (props: Props) => {
  const {text, close, valid} = props

  return (
    <TwContainer $valid={valid}>
      <TwTitle $valid={valid}>{text}</TwTitle>

      <TwClose onClick={close}>
        <Icon icon={'IconCustomClose'} />
      </TwClose>
    </TwContainer>
  )
}
